import { getLabelDecorationForExpiration } from '@/plugins/globals.plugin.js'

// Due to the lack of some icons that were not in the material icons
// library used in the rest of the project, svg was used for
// the object list page to display all the icons.
// https://materialdesignicons.com/
const keyOn = 'M22 19h-6v-4h-2.68c-1.14 2.42-3.6 4-6.32 4-3.86 0-7-3.14-7-7s3.14-7 7-7c2.72 0 5.17 1.58 6.32 4H24v6h-2v4zm-4-2h2v-4h2v-2H11.94l-.23-.67C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18v4zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z'
const keyOff = 'M2.81,2.81L1.39,4.22l2.59,2.59C2.2,7.85,1,9.79,1,12c0,3.31,2.69,6,6,6c2.22,0,4.15-1.21,5.19-3l7.59,7.61l1.41-1.41 L2.81,2.81z M7,16c-2.21,0-4-1.79-4-4c0-1.67,1.02-3.1,2.47-3.7l1.71,1.71C7.12,10,7.06,10,7,10c-1.1,0-2,0.9-2,2s0.9,2,2,2 s2-0.9,2-2c0-0.06,0-0.12-0.01-0.18l1.74,1.74C10.22,14.48,9.14,16,7,16z M17,14.17V13h-1.17L17,14.17z M13.83,11H21v2h-2v3l2,2 v-3h2V9H11.83L13.83,11z'
const othersOn = 'M12,15H10V13H12V15M18,15H14V13H18V15M8,11H6V9H8V11M18,11H10V9H18V11M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4Z'
const othersOff = 'M20.59,20.87L19.17,22.29L16.88,20H4A2,2 0 0,1 2,18V6C2,5.74 2.05,5.5 2.14,5.26L1.17,4.29L2.59,2.87L3.73,4L20.59,20.87V20.87M6.54,4H20A2,2 0 0,1 22,6V18C22,18.41 21.87,18.8 21.66,19.12L20,17.46V6H8.54L6.54,4M4,18H14.88L11.88,15H10V13.12L7.88,11H6V9.12L4,7.12V18M18,15H17.54L15.54,13H18V15M18,11H13.54L11.54,9H18V11Z'
const certOn = 'M18,2A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H18M18,4H13V12L10.5,9.75L8,12V4H6V20H18V4Z'
const certOff = 'M6 14.8L4 16.8V4C4 2.9 4.89 2 6 2H18C18.24 2 18.47 2.04 18.68 2.12L16.8 4H13V7.8L10.79 10L10.5 9.75L8 12V4H6V14.8M22.89 3L20 5.89V20C20 21.11 19.11 22 18 22H6C5.42 22 4.9 21.75 4.54 21.35L3.16 22.73L1.89 21.46L21.61 1.73L22.89 3M18 7.89L6 19.89V20H18V7.89Z'
const certExpiration = 'M20 11.26V4C20 2.9 19.11 2 18 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H11.11C12.37 23.24 14.09 24 16 24C19.87 24 23 20.87 23 17C23 14.62 21.81 12.53 20 11.26M18 4V10.29C17.37 10.11 16.7 10 16 10C14.93 10 13.91 10.25 13 10.68V4H18M6 4H8V12L10.5 9.75L12.1 11.19C10.23 12.45 9 14.58 9 17C9 18.08 9.25 19.09 9.68 20H6V4M16 22C13.24 22 11 19.76 11 17S13.24 12 16 12 21 14.24 21 17 18.76 22 16 22M16.5 17.25L19.36 18.94L18.61 20.16L15 18V13H16.5V17.25Z'

export default {
  computed: {
    appTheme () {
      return this.$vuetify.theme.dark ? 'dark' : 'light'
    }
  },
  methods: {
    getClassesForExpirationDate (expiration) {
      const status = getLabelDecorationForExpiration(expiration)
      const classes = []
      if (status?.expired) classes.push('striked')
      if (status?.condition) classes.push(`${status.condition}--text`)
      return classes
    },
    getKeyFQN (partitionName, keyName) {
      let fqn = ''
      if (partitionName) fqn = partitionName + '/'
      return fqn.concat(keyName)
    },
    getKeyIconColor (type) {
      const algDetail = this.$store.getters['keys/getKeyType']({
        type
      })
      let iconColor
      switch (algDetail.type) {
        case 'SECP':
        case 'BrainPool':
        case 'Edwards':
        case 'Edwards-x':
        case 'RSA':
        case 'DSA':
        case 'DH':
        case 'X9.62':
        case 'BTC MINI KEY':
        case 'BIP32 SXPRIV':
        case 'BIP39 SXPRIV':
        case 'BIP32 XPRIV':
        case 'BIP32 Edwards XPRIV':
          iconColor = 'asym_icon_color'
          break
        case 'DES':
        case '3DES':
        case 'DESX':
        case 'AES':
        case 'ARC4':
        case 'ARC5':
        case 'HMAC MD5':
        case 'HMAC SHA1':
        case 'HMAC SHA2':
        case 'HMAC SHA3':
          iconColor = 'sym_icon_color'
          break
        case 'x.509':
        case 'RSA PUB KEY':
        case 'ECC PUB KEY':
        case 'BLOB':
          iconColor = 'default_icon_color'
          break
        default:
          iconColor = 'default_icon_color'
          break
      }
      const colorRgb = this.$vuetify.theme.themes[this.appTheme][iconColor]
      return colorRgb
    },
    getKeyIcon (item) {
      if (item.type.type === 'x.509') {
        const status = getLabelDecorationForExpiration(item.data.notAfter)
        if (status === null && !item.blocked) {
          return certOn
        } else if (status !== null && status.expired === true) {
          return certExpiration
        } else {
          return certOff
        }
      } else if (!item.blocked) {
        switch (item.type.type) {
          case 'SECP':
          case 'BrainPool':
          case 'RSA':
          case 'DSA':
          case 'DH':
          case 'DES':
          case '3DES':
          case 'DESX':
          case 'AES':
          case 'ARC4':
          case 'ARC5':
          case 'X9.62':
          case 'Edwards':
          case 'Edwards-x':
          case 'HMAC MD5':
          case 'HMAC SHA1':
          case 'HMAC SHA2':
          case 'HMAC SHA3':
          case 'RSA PUB KEY':
          case 'ECC PUB KEY':
          case 'BTC MINI KEY':
          case 'BIP32 SXPRIV':
          case 'BIP39 SXPRIV':
          case 'BIP32 XPRIV':
          case 'BIP32 Edwards XPRIV':
            return keyOn

          case 'PKCS#7':
          case 'CRL':
            return certOn
          default:
            return othersOn
        }
      } else {
        switch (item.type.type) {
          case 'SECP':
          case 'BrainPool':
          case 'RSA':
          case 'DSA':
          case 'DH':
          case 'DES':
          case '3DES':
          case 'DESX':
          case 'AES':
          case 'ARC4':
          case 'ARC5':
          case 'X9.62':
          case 'Edwards':
          case 'Edwards-x':
          case 'HMAC MD5':
          case 'HMAC SHA1':
          case 'HMAC SHA2':
          case 'HMAC SHA3':
          case 'RSA PUB KEY':
          case 'ECC PUB KEY':
          case 'BTC MINI KEY':
          case 'BIP32 SXPRIV':
          case 'BIP39 SXPRIV':
          case 'BIP32 XPRIV':
          case 'BIP32 Edwards XPRIV':
            return keyOff

          case 'PKCS#7':
          case 'CRL':
            return certOff
          default:
            return othersOff
        }
      }
    },
    getFriendlyObjType (type) {
      const algDetail = this.$store.getters['keys/getKeyType']({
        type
      })
      switch (algDetail.type) {
        case 'SECP':
        case 'BrainPool':
        case 'Edwards':
        case 'Edwards-x':
        case 'RSA':
        case 'DSA':
        case 'DH':
        case 'X9.62':
        case 'RSA PUB KEY':
        case 'ECC PUB KEY':
        case 'BTC MINI KEY':
        case 'BIP32 SXPRIV':
        case 'BIP39 SXPRIV':
        case 'BIP32 XPRIV':
        case 'BIP32 Edwards XPRIV':
          return 'asymmetric_key'
        case 'DES':
        case '3DES':
        case 'DESX':
        case 'AES':
        case 'ARC4':
        case 'ARC5':
        case 'HMAC MD5':
        case 'HMAC SHA1':
        case 'HMAC SHA2':
          return 'symmetric_key'
        case 'x.509': return 'certificate'
        case 'BLOB':
        default:
          return 'other'
      }
    },
    isExportable ({ attr }) {
      const OBJ_ATTR_EXPORT = 1
      return attr & OBJ_ATTR_EXPORT
    },
    hasBchainAttr ({ attr }) {
      const OBJ_ATTR_BCHAIN = 16384
      const XPRIV_ATTR_BCHAIN = 16385
      return attr === OBJ_ATTR_BCHAIN || attr === XPRIV_ATTR_BCHAIN
    },
    needsCSRP10 (type) {
      return this.$store.getters['keys/getNeedsCSRP10']({ type })
    }
  }
}
